import React, {useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import useMediaQuery from "@material-ui/core/useMediaQuery"
import {MenuContext} from "../"

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    backgroundColor:"#b60011",
    boxShadow: "none"
  },
  toolbar: {
    backgroundColor:"#b60011",
  
  },
  title: {
    fontFamily: "proxima-nova, sans-serif",
    fontSize:"22px",
    fontWeight:700,
    marginLeft: theme.spacing(1),
    textTransform: "capitalize",
  },
  titleButton: {
    flex: 1,
    justifyContent: "left",
    "&:focus-visible": {
      backgroundColor: "hsl(208, 89%, 34%) !important",
        color: "#fff",  
    }
  },
  headerText: {
    fontSize: "18px !important",
    fontFamily: "proxima-nova,sans-serif",
    fontWeight: 700,
    margin: "10px 0 10px 0",
    display: "block",
    borderStyle: "none",
    marginLeft:"10px",
    paddingTop: "10px",
    color:"#1d1d1b",
    "&.Mui-focused": {
      backgroundColor: "white !important",
        color: "#1d1d1b !important",  
    }
  },
  sideMargin: {
    marginLeft:"10px"
  },
  mainTextStyle: {
    fontSize:"18px",
    textTransform: "capitalize !important",
    fontFamily: "proxima-nova, sans-serif",
  },
  speedTextStyle: {
    fontSize:"18px",
    textTransform: "lowercase",
    fontFamily: "proxima-nova, sans-serif",
  },
  spanTextStyle: {
    fontWeight: 1000,
    marginLeft: "2px",
    marginRight: "2px"
  },
  modalButton: {
    marginRight:"5px",
    backgroundColor:"white",
    textTransform: "capitalize !important",
    color:"#1d1d1b",
    fontSize:"16px",
    fontFamily: "proxima-nova, sans-serif",
    borderRadius: "0 !important",  
    padding:0,
    overflow:"hidden",
    "&:focus-visible": {
      backgroundColor: "hsl(208, 89%, 34%) !important",
        color: "#fff !important",  
    }
  },
  modalButtonMobile: {
    backgroundColor:"white",
    textTransform: "capitalize !important",
    color:"#1d1d1b",
    fontSize:"16px",
    lineHeight:"24px;",
    fontFamily: "proxima-nova, sans-serif",
    borderRadius: "0 !important",  
    padding:"5px 0 5px 0",
    overflow:"hidden",
    "&:focus-visible": {
      backgroundColor: "hsl(208, 89%, 34%) !important",
        color: "#fff !important",  
    }
  },
  radio: {
    fontFamily: "proxima-nova, sans-serif",
    color:"#1d1d1b",
    fontSize:"18px",
    '&$checked': {
      color: '#b60011'
    }
  },
  cssLabel: {
    color: "#1d1d1b",
    "&.Mui-focused": {
      backgroundColor: "hsl(208, 89%, 34%) !important",
        color: "#fff !important",  
    }
  },
  breakLine: {
    '@media (max-width: 768px)'  : {
    display:"block"
    }
  },
  closeButton: {
    fontSize:"30px !important",
  },
  appBarButton: {
    "&:focus-visible": {
      backgroundColor: "hsl(208, 89%, 34%) !important",
        color: "#fff",  
    }
  },
  checked: {}
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


export default function Settings(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const showMenuMobile = useMediaQuery("(max-width: 960px)");
  const { windValue, tempValue, handleSettingChange} = useContext(MenuContext);


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleWindChange = (event) => {
    handleSettingChange(event.target.value, tempValue);
    localStorage.setItem("WindSpeed", event.target.value);
  }

  const handleTempChange = (event) => {
    handleSettingChange(windValue, event.target.value );
    localStorage.setItem("Temperature", event.target.value);
  }

  return (      
    <>
      <Button disableRipple={true} className={showMenuMobile ? classes.modalButtonMobile : classes.modalButton} onClick={handleClickOpen}>
        Settings<FontAwesomeIcon style={{marginLeft:"8px"}} icon={faCog} />
      </Button>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
          <Button color="inherit" onClick={handleClose} className={classes.titleButton} disableRipple={true}>
            <FontAwesomeIcon className={classes.closeButton} icon={faTimes} />
            <Typography className={classes.title}>
              Settings 
            </Typography>
            </Button>
            <Button  color="inherit" onClick={handleClose} disableRipple={true} className={classes.appBarButton}>
              <p className={classes.mainTextStyle}>Wind <span className={classes.speedTextStyle}>speed</span> <span className={classes.spanTextStyle}>{windValue}</span>&nbsp;&nbsp;&nbsp; 
              <span className={classes.breakLine}>Temperature <span className={classes.spanTextStyle}>{tempValue}</span></span></p>
              </Button>
          </Toolbar>
        </AppBar>
        <FormControl component="fieldset">
        <FormLabel style={{zIndex:"1"}} className={classes.headerText} component="legend">Wind speed</FormLabel>
      <RadioGroup className={classes.sideMargin} value={windValue}  onChange={handleWindChange} aria-label="wind" name="windspeed">
        <FormControlLabel value="Beaufort" control={<Radio 
        classes={{root: classes.radio, checked: classes.checked}}/>} label="Beaufort force" />
        <FormControlLabel value="Miles" control={<Radio  
        classes={{root: classes.radio, checked: classes.checked}}/>} label="Miles per hour" />
        <FormControlLabel value="Kilometres" control={<Radio  
        classes={{root: classes.radio, checked: classes.checked}}/>} label="Kilometres per hour" />
        <FormControlLabel value="Knots" control={<Radio 
        classes={{root: classes.radio, checked: classes.checked}}/>} label="Knots" />
      </RadioGroup>
    </FormControl>
        <Divider/>
    <FormControl component="fieldset">
      <FormLabel className={classes.headerText} component="legend">Temperature</FormLabel>
      <RadioGroup className={classes.sideMargin} value={tempValue} onChange={handleTempChange} aria-label="temperature" name="temp">
        <FormControlLabel value="Celsius" control={<Radio  
        classes={{root: classes.radio, checked: classes.checked}}/>} label="°Celsius" />
        <FormControlLabel value="Fahrenheit" control={<Radio 
        classes={{root: classes.radio, checked: classes.checked}}/>} label="°Fahrenheit" />
      </RadioGroup>
    </FormControl>
      </Dialog>
      </>
  );
}